import {
  Box,
  Button,
  Icon,
  Text,
  VStack,
} from '@chakra-ui/react'
import { IconType } from 'react-icons'
import { FiInbox } from 'react-icons/fi'

interface EmptyStateProps {
  icon?: IconType
  title: string
  description?: string
  actionLabel?: string
  onAction?: () => void
}

export function EmptyState({
  icon = FiInbox,
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <Box
      p={8}
      textAlign="center"
      bg="whiteAlpha.50"
      borderRadius="lg"
      border="1px dashed"
      borderColor="whiteAlpha.200"
    >
      <VStack gap={4}>
        <Box p={4} borderRadius="full" bg="whiteAlpha.100">
          <Icon as={icon} boxSize={8} color="whiteAlpha.500" />
        </Box>
        <Text fontWeight="medium" color="whiteAlpha.800">
          {title}
        </Text>
        {description && (
          <Text fontSize="sm" color="whiteAlpha.600" maxW="sm">
            {description}
          </Text>
        )}
        {actionLabel && onAction && (
          <Button colorPalette="teal" size="sm" onClick={onAction}>
            {actionLabel}
          </Button>
        )}
      </VStack>
    </Box>
  )
}
